import { useIsMobile } from "@/hooks/use-mobile";
import { ROLE_BOM } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { getOwnerBomBase, routes } from "@/routes/utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const useAddEditCommunity = () => {
  const { id, action } = useParams();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const isView = true;
  const isEdit = action == "edit" || action == "edit-details";
  const isAdd = action == "add";
  const [currentStep, setCurrentStep] = useState<number>(1);
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isBom = currentRole == ROLE_BOM;

  useEffect(() => {
    if ((isEdit || isAdd) && location?.state?.step) {
      setCurrentStep(parseInt(location?.state?.step) || 1);
    }
  }, [location, location?.state, action]);

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onBackClick = () => {
    navigate(`/${getOwnerBomBase(location.pathname)}/${routes.communities}`);
  };

  const onStepperClick = (curr_step: number) => {
    if (isView || isEdit) setCurrentStep(curr_step);
  };

  return {
    currentStep,
    setCurrentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    id,
    onPreviousStepClick,
    isMobile,
    isBom,
  };
};

export default useAddEditCommunity;
